import styled from "styled-components";

const InitialsBackground = () => {
  return <Initials>FB</Initials>;
};

export default InitialsBackground;

const Initials = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 165vh;
  font-weight: lighter;
  color: #cacaca3d;
  pointer-events: none;
  z-index: 0;
  letter-spacing: -10px;
  font-family: "Monoton", sans-serif;
  font-style: normal;
`;